console.log("[Application] Loading application.js...")

import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import "./channels/voice_notification_channel"
import "./channels/webrtc_manager"
import "./channels/push_notification_manager"
import "./drawing/index"
import "./app_transitions"

// Start Stimulus application
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import and register controllers
import ModalController from "./controllers/modal_controller"
application.register("modal", ModalController)

export { application }
